/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.equipment.assign.controllers', [])

.controller('ResourcesEquipmentAssignController', ['$scope', function($scope) {

    $scope.resourcesEquipmentAssign = "Your spankin new application.resources.equipment.assign view!";

}]);